<script>
import AccountsServices from '@/services/accounts'
import AvatarUtils from '@/utils/avatarUtils'
import ProfilePicture from '@/components/ProfilePicture'

export default
{
    name: 'account-preview',

    props:
    {
        user: {type: Object, required: true}
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='account-preview'>
                <profile-picture src={this.user.profilePictureUrl} on-click={this.onProfilePictureClicked} />
                <div class='name'>{this.user.firstName} {this.user.lastName}</div>
                <div class='identifier'>{this.user.username}</div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        async onProfilePictureClicked ()
        {
            const newPictureUrl = AvatarUtils.generateRandomAvatarUrl(Number.parseInt(Math.random() * 10000))
            this.$store.state.user.profilePictureUrl = newPictureUrl
            await AccountsServices.updateAccount(this.$store.state.user.token, {profilePictureUrl: newPictureUrl})
        },
    },

    components:
    {
        ProfilePicture,
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.account-preview
{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    text-align: center;

    .profile-picture
    {
        .WidthHeight(160px);
        margin-top: -80px;

        #Circle-Background
        {
            fill: var(--theme-border-color);
        }
    }

    .name
    {
        margin-top: 10px;
        font-weight: 700;
        font-size: 22px;
        text-transform: capitalize;
        color: var(--theme-text-color-lighter);
    }

    .identifier
    {
        margin-top: 5px;
        color: var(--theme-text-color-extra-light);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AccountPreview.vue